import { render, staticRenderFns } from "./TeacherEditionModal.vue?vue&type=template&id=3f106b57&scoped=true&"
import script from "./TeacherEditionModal.vue?vue&type=script&lang=js&"
export * from "./TeacherEditionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f106b57",
  null
  
)

export default component.exports